<template>
    <card>
        <h3 class="p-3 d-flex flex-column flex-lg-row align-items-center justify-content-between">
            <b>Sistema de Gestión : Despachos</b>
        </h3>
        <hr />

        <!-- Navegación dinámica -->
        <div class="row justify-content-center text-center pt-3 pb-2 bg-dark rounded-pill m-2">
            <div class="row col-12 flex-wrap justify-content-center gap-3">
                <div v-for="boton in botonesNavegacion" :key="boton.paso" class="p-3 col-6 col-sm-3 col-md-2 col-lg-1">
                    <button class="btn-evaluacion btn-circle btn-secondary" :class="paso === boton.paso ? 'active' : ''"
                        :disabled="loading" @click="cambiarVista(boton.paso)">
                        <span class="h5">
                            <i :class="boton.icono"></i>
                        </span>
                    </button>
                    <p class="pt-2 small">{{ boton.label }}</p>
                </div>
            </div>
        </div>

        <div class="m-2 p-3 mt-3 rounded-pill">
            <!-- Loading state -->
            <div v-if="loading" class="text-center py-5">
                <div class="loading-container">
                    <div class="emoji-container mb-3">
                        <span class="emoji animate-bounce h2" role="img" aria-label="Car">🚗</span>
                        <span class="emoji animate-pulse h2" role="img" aria-label="Hourglass">⏳</span>
                        <span class="emoji animate-bounce h2" role="img" aria-label="Thinking">🤔</span>
                    </div>
                    <span class="font-weight-bold text-primary h2">Obteniendo información...</span>
                    <p class="loading-message text-muted">
                        Espere un momento mientras preparamos los datos.
                    </p>
                    <div class="spinner-border text-primary" role="status">
                        <span class="sr-only">Cargando...</span>
                    </div>
                </div>
            </div>

            <!-- Content -->
            <div v-if="!loading">
                <div class="d-flex flex-row flex-wrap col-12 align-items-center justify-content-between">
                    <div class="col-12 col-sm-8 d-flex flex-wrap flex-sm-nowrap" :class="DiferenteADespacho()">
                        <div class="col-12 bg-dark bg-dark-hover p-3 rounded">
                            <h5>{{ tituloOpcion }}</h5>
                            <p class="text-white-50">{{ descripcionOpcion }}</p>

                            <!-- Información de paginación -->
                            <div v-if="requierePaginacion(paso) && metaInfo" class="mt-2">
                                <small class="text-white-50">
                                    Mostrando {{ metaInfo.per_page }} de {{ metaInfo.total }} registros
                                    (Página {{ metaInfo.current_page }} de {{ metaInfo.last_page }})
                                </small>
                            </div>
                        </div>
                    </div>

                    <!-- Botón agregar solo para Despacho -->
                    <div class="col-12 col-sm-4" v-if="paso === 'Despacho'">
                        <BtnAddCardTable class="py-4 d-flex justify-content-end" @click="abrirModalForm()"
                            :text="'Ingresar Despacho'" />
                    </div>
                </div>

                <!-- DataTable dinámico -->
                <DataTableButtons :items="itemsListar" :headers="configuracionActual.headers"
                    :keys="configuracionActual.keys" :actions1="configuracionActual.actions.action1?.handler || null"
                    :button1="configuracionActual.actions.action1?.icon || ''"
                    :titleButton1="configuracionActual.actions.action1?.title || ''"
                    :actions2="configuracionActual.actions.action2?.handler || null"
                    :button2="configuracionActual.actions.action2?.icon || ''"
                    :titleButton2="configuracionActual.actions.action2?.title || ''"
                    :actions3="configuracionActual.actions.action3?.handler || null"
                    :button3="configuracionActual.actions.action3?.icon || ''"
                    :titleButton3="configuracionActual.actions.action3?.title || ''" :tableId="`datatable_${paso}`"
                    class="mt-2 w-100 h-100" />
            </div>
        </div>

        <!-- Modales -->
        <b-modal ref="Despacho" size="xl" hide-footer header-class="bg-dark border-none pb-4"
            content-class="bg-dark rounded ">
            <formularioDespacho @submit="registrarDespacho"></formularioDespacho>
        </b-modal>

        <b-modal ref="Adicionales" size="xl" hide-footer hide-header content-class="bg-dark rounded ">
            <formularioGeneral :idDespacho="idDespacho"></formularioGeneral>
        </b-modal>

        <b-modal ref="modalEditar" size="xl" hide-footer hide-header content-class="bg-dark rounded ">
            <component :is="formularioActual" @submit="actualizarDespacho" :preCarga="itemSeleccionado"
                class="bg-dark rounded" />
        </b-modal>
    </card>
</template>

<script>
import BtnAddCardTable from "@/components/btnCardTable/btnAddCardTable.vue";
import DataTableButtons from "../../../../components/Datatable/DatatableButtons.vue";
import formularioDespacho from "./Formularios/formularioDespacho.vue";
import formularioGeneral from "./Formularios/formularioGeneral.vue";
import formularioVehiculo from "./Formularios/formularioVehiculo.vue";
import formularioDespachoRuta from "./Formularios/formularioDespachoRuta.vue";
import formularioDespachoConductor from "./Formularios/formularioDespachoConductor.vue";
import formularioDespachoNovedad from "./Formularios/formularioDespachoNovedad.vue";
import Swal from 'sweetalert2';

// Importar configuraciones externas
import { ENDPOINTS } from '../Config/endpoints'
import { BOTONES_NAVEGACION } from '../Config/navegacion'
import { CONFIGURACIONES_TABLA } from '../Config/tablas'
import { OPCIONES_VISTA } from '../Config/vistas'

export default {
    components: {
        BtnAddCardTable,
        DataTableButtons,
        formularioDespacho,
        formularioGeneral,
        formularioVehiculo,
        formularioDespachoRuta,
        formularioDespachoConductor,
        formularioDespachoNovedad,
    },

    data() {
        return {
            token: null,
            tokenParametricas: null,
            loading: false,
            paso: 'Despacho',
            idDespacho: null,
            itemSeleccionado: null,
            tituloOpcion: null,
            descripcionOpcion: null,
            metaInfo: null,
            paginacionConfig: {
                page: 1,
                numero_items: 50
            },
            itemsListar: null,

            // Configuraciones importadas
            botonesNavegacion: BOTONES_NAVEGACION,
            configuracionesTabla: CONFIGURACIONES_TABLA,
            endpoints: ENDPOINTS,
            opcionesVista: OPCIONES_VISTA
        };
    },

    computed: {
        configuracionActual() {
            const config = this.configuracionesTabla[this.paso];
            if (!config) {
                console.warn(`No se encontró configuración para: ${this.paso}`);
                return { headers: [], keys: [], actions: {} };
            }

            // Configurar acciones dinámicamente
            const actions = {
                action1: null,
                action2: null,
                action3: null
            };

            if (this.paso === 'Despacho') {
                actions.action1 = {
                    handler: this.abrirModalComplementarios,
                    icon: 'fa-solid fa-plus',
                    title: 'Agregar información'
                };
                actions.action2 = {
                    handler: this.abrirModalEditar,
                    icon: 'fa-solid fa-pen',
                    title: 'Editar despacho'
                };
                actions.action3 = {
                    handler: this.cambiarEstado,
                    icon: 'fa-solid fa-rotate',
                    title: 'Cambiar estado despacho'
                };
            } else {
                actions.action1 = {
                    handler: this.abrirModalEditar,
                    icon: 'fa-solid fa-pen',
                    title: `Editar ${this.paso.toLowerCase()}`
                };
                actions.action2 = {
                    handler: this.cambiarEstado,
                    icon: 'fa-solid fa-rotate',
                    title: `Cambiar estado ${this.paso.toLowerCase()}`
                };
            }

            return {
                ...config,
                actions
            };
        },

        formularioActual() {
            const formularios = {
                'Despacho': 'formularioDespacho',
                'Vehiculo': 'formularioVehiculo',
                'Ruta': 'formularioDespachoRuta',
                'Autorizaciones': 'formularioAutorizacion',
                'Conductores': 'formularioDespachoConductor',
                'Novedades': 'formularioDespachoNovedad',
            };
            return formularios[this.paso] || 'formularioDespacho';
        }
    },

    methods: {
        async obtenerToken() {
            try {
                const respuesta = await this.$store.dispatch("hl_post_cookie", {
                    path: 'ApiSuperTransporteGenerales/TokenApiSuperTransporte'
                });
                console.log("Token obtenido", respuesta);
            } catch (error) {
                console.warn("No se ha logrado generar el token", error);
            }
        },
        async obtenerTokenParametricas() {
            try {
                const respuesta = await this.$store.dispatch("hl_post_cookie", {
                    path: 'ApiSuperTransporteGenerales/TokenParametricas'
                });
                console.log("Token parámetricas obtenido", respuesta);
            } catch (error) {
                console.warn("No se ha logrado generar el token de parámetricas", error);
            }
        },

        async cambiarVista(nuevoPaso) {
            if (this.paso === nuevoPaso || this.loading) return;
            this.loading = true;
            await this.obtenerValores(nuevoPaso);
        },

        async obtenerValores(nuevoPaso) {
            this.paso = nuevoPaso;
            const endpoint = this.endpoints[nuevoPaso];

            if (!endpoint) {
                console.error(`No se encontró endpoint para: ${nuevoPaso}`);
                this.loading = false;
                return;
            }

            let urlPath = `ApiSuperTransporteDespachos/${endpoint}`;
            if (this.requierePaginacion(nuevoPaso)) {
                urlPath += `?page=${this.paginacionConfig.page}&numero_items=${this.paginacionConfig.numero_items}`;
            }

            try {
                const response = await this.$store.dispatch('hl_get_cookie', {
                    path: urlPath
                });

                console.log("Respuesta completa del servidor:", response);
                this.procesarRespuesta(nuevoPaso, response);

            } catch (error) {
                console.warn("Ha ocurrido un error al obtener los valores", error);
                this.lanzarAlerta('error', 'Error', `Error al cargar los datos de ${nuevoPaso}`);
            } finally {
                this.loading = false;
            }
        },

        procesarRespuesta(paso, response) {
            switch (paso) {
                case "Autorizaciones":
                    this.itemsListar = response.flatMap(valor => valor.autorizacion);
                    this.metaInfo = null;
                    break;
                case "Conductores":
                    this.itemsListar = response.data;
                    this.metaInfo = null;
                    break;
                default:
                    if (this.requierePaginacion(paso)) {
                        this.itemsListar = response.data;
                        this.metaInfo = response.meta;
                    } else {
                        this.itemsListar = response;
                        this.metaInfo = null;
                    }
            }
            console.log("Los datos procesados son:", this.itemsListar);
        },

        requierePaginacion(paso) {
            const pasosPaginados = ['Novedades', 'Llegadas', 'NovedadesConductor', 'NovedadesVehiculo', 'LlegadasConductor', 'LlegadasVehiculo'];
            return pasosPaginados.includes(paso);
        },

        async cambiarPagina(nuevaPagina) {
            if (this.requierePaginacion(this.paso)) {
                this.paginacionConfig.page = nuevaPagina;
                this.loading = true;
                await this.obtenerValores(this.paso);
            }
        },

        async cambiarNumeroItems(nuevoNumero) {
            if (this.requierePaginacion(this.paso)) {
                this.paginacionConfig.numero_items = nuevoNumero;
                this.paginacionConfig.page = 1;
                this.loading = true;
                await this.obtenerValores(this.paso);
            }
        },

        async registrarDespacho(item, preCarga) {
            if (preCarga == null) {
                try {
                    console.log("Formulario enviado:", item);
                    let response = await this.$store.dispatch('hl_post_cookie', {
                        path: 'ApiSuperTransporteDespachos/CrearDespacho',
                        data: item
                    })
                    console.log("La respuesta es: ", response);

                    if (response.errores) {
                        this.lanzarAlerta('warning', "¡Ha ocurrido un error!", `${response.mensaje}`)
                    }
                    else {
                        this.lanzarAlerta('success', "¡Registro guardado exitosamente!", `${response.mensaje}`)
                        this.obtenerValores('Despacho')
                        this.loading = false;
                    }
                }
                catch (error) {
                    this.lanzarAlerta('warning', "¡Ha ocurrido un error!", `El error es: ${error}`)
                    console.warn("Hubo un error al registrar el Despacho", error);
                }
            }
            else {
                return
            }
        },

        // Resto de métodos simplificados...
        async actualizarDespacho(item) {
            console.log('🔍 === INICIO DEBUG ACTUALIZACIÓN ===');
            console.log('🔍 Paso actual:', this.paso);

            try {
                if (!this.itemSeleccionado || !this.obtenerIdItem(this.itemSeleccionado)) {
                    throw new Error('No se ha seleccionado un elemento válido');
                }

                const idRegistro = this.obtenerIdItem(this.itemSeleccionado);
                const endpoint = this.obtenerEndpointActualizacion();

                console.log("este es el endpoint", endpoint);

                let despacho = null

                if (endpoint == "ActualizarVehiculo") {
                    despacho = "idDespachos"
                }
                else if (endpoint == "ActualizarNovedad") {
                    despacho = "id_despacho"
                }
                else if (endpoint === "ActualizarDespacho") {
                    despacho = "id"
                }
                else {
                    despacho = "idDespacho"
                }
                item = {
                    ...item, [despacho]: endpoint == "ActualizarVehiculo" ? this.itemSeleccionado.id_despachos : endpoint == "ActualizarDespacho" ? this.itemSeleccionado.id : this.itemSeleccionado.id_despacho,
                }
                if (endpoint == "ActualizarNovedad") {
                    item = { ...item, "id": this.itemSeleccionado.id }
                }

                console.log('🔍 Item recibido del formulario:', JSON.stringify(item, null, 2));

                let put = null

                if (endpoint == "ActualizarNovedad") {
                    put = await this.$store.dispatch('hl_put_cookie', {
                        path: `ApiSuperTransporteDespachos/${endpoint}`,
                        data: item
                    });
                }
                else {
                    put = await this.$store.dispatch('hl_put_cookie', {
                        path: `ApiSuperTransporteDespachos/${endpoint}/${idRegistro}`,
                        data: item
                    });
                }


                if (put.codigoError) {
                    this.lanzarAlerta("warning", "¡Error al actualizar!", put.mensaje);
                } else if (put.id || put.codigoDespacho || put.success || put.mensaje) {
                    this.lanzarAlerta("success", "¡Actualización exitosa!", put.mensaje || 'Registro actualizado correctamente');
                    this.$refs.modalEditar.hide();
                    await this.obtenerValores(this.paso);
                } else {
                    this.lanzarAlerta("warning", "Respuesta inesperada", "La operación se completó pero la respuesta no es la esperada");
                }
            } catch (error) {
                console.error("❌ Error completo al actualizar:", error);
                this.lanzarAlerta("error", "¡Error al actualizar!", error.message || error);
            }
        },

        async abrirModalEditar(itemId) {
            if (!this.itemsListar || !Array.isArray(this.itemsListar)) {
                this.lanzarAlerta('error', 'Error', 'No hay datos disponibles para editar');
                return;
            }

            const itemCompleto = this.itemsListar.find(item => item.id == itemId);
            if (!itemCompleto) {
                this.lanzarAlerta('error', 'Error', 'No se encontró el registro seleccionado');
                return;
            }

            this.itemSeleccionado = { ...itemCompleto };
            this.$refs.modalEditar.show();
        },

        // prepararDatosActualizacion(item) {
        //     // Lógica simplificada usando configuraciones
        //     const preparadores = {
        //         'Despacho': () => ({
        //             "id_despacho_terminal": item.id_despacho_terminal,
        //             "terminal_despacho": item.terminal_despacho,
        //             "nit_empresa_transporte": item.nit_empresa_transporte,
        //             "razon_social": item.razon_social,
        //             "numero_pasajero": item.numero_pasajero,
        //             "valor_tiquete": item.valor_tiquete,
        //             "valor_total_tasa_uso": item.valor_total_tasa_uso,
        //             "valor_prueba_alcoholimetria": item.valor_prueba_alcoholimetria,
        //             "tipo_despacho": item.tipo_despacho,
        //             "observaciones": item.observaciones,
        //             "estado": item.estado
        //         }),
        //         // Agregar otros preparadores según necesidad...
        //     };

        //     const preparador = preparadores[this.paso];
        //     return preparador ? preparador() : item;
        // },

        obtenerEndpointActualizacion() {
            const endpoints = {
                Despacho: 'ActualizarDespacho',
                Vehiculo: 'ActualizarVehiculo',
                Ruta: 'ActualizarRuta',
                Autorizaciones: 'ActualizarAutorizacion',
                Conductores: 'ActualizarConductor',
                Novedades: 'ActualizarNovedad',
                Llegadas: 'ActualizarLlegada'
            };
            return endpoints[this.paso];
        },

        obtenerIdItem(item) {
            return item.id;
        },

        abrirModalForm() {
            this.$refs.Despacho.show();
        },

        abrirModalComplementarios(item) {
            this.idDespacho = item;
            this.$refs.Adicionales.show();
        },

        DiferenteADespacho() {
            if (this.paso !== "Despacho") {
                const opcion = this.opcionesVista[this.paso] || this.opcionesVista["Conductores"];
                this.tituloOpcion = opcion.titulo;
                this.descripcionOpcion = opcion.descripcion;
                return "col-sm-12";
            } else {
                this.tituloOpcion = "Despacho";
                this.descripcionOpcion = "Aquí se crean los diferentes despachos que servirán como base para asignar vehículos, rutas, autorizaciones y conductores.";
            }
        },

        async cambiarEstado(item) {
            const endpoints = {
                Despacho: 'DeshabilitarDespacho',
                Vehiculo: 'DeshabilitarVehiculo',
                Ruta: 'DeshabilitarRuta',
                Autorizaciones: 'DeshabilitarAutorizaciones',
                Conductores: 'DeshabilitarConductor',
                Novedades: 'DeshabilitarNovedad',
                NovedadesConductor: 'DeshabilitarNovedadConductor',
                NovedadesVehiculo: 'DeshabilitarNovedadVehiculo',
                LlegadasVehiculo: 'DeshabilitarLlegadaVehiculo',
                LlegadasConductor: 'DeshabilitarLlegadaConductor'
            };

            const endpoint = endpoints[this.paso];
            try {
                const response = await this.$store.dispatch('hl_patch_cookie', {
                    path: `ApiSuperTransporteDespachos/${endpoint}/${item}`
                });

                if (response.mensaje === "Cambio de estado exitoso" ||
                    response.mensaje === "Conductor activado exitosamente" ||
                    response.mensaje === "Conductor desactivado exitosamente") {
                    this.lanzarAlerta('success', '¡Éxito!', response.mensaje);
                    await this.obtenerValores(this.paso);
                } else {
                    this.lanzarAlerta('warning', '¡Error!', 'No se ha cambiado el estado.');
                }
            } catch (error) {
                console.warn("Hubo un error al cambiar el estado", error);
            }
        },

        lanzarAlerta(tipo, titulo, texto) {
            Swal.fire({
                icon: tipo,
                title: titulo,
                text: texto,
                confirmButtonText: 'Aceptar'
            });
        }
    },

    async mounted() {
        await this.obtenerToken();
        await this.obtenerTokenParametricas();
        await this.obtenerValores(this.paso);
    }
};
</script>




<style lang="css">
.btn-evaluacion {
    border: solid 3px #16a275;
    transition: all 0.3s ease;
}

.btn-evaluacion:hover:not(:disabled) {
    border-color: #12d1df;
    transform: translateY(-2px);
}

.btn-evaluacion.active {
    border-color: #df122e;
    background-color: #df122e;
    color: white;
}

.btn-evaluacion:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.bg-button-dark {
    background-color: #10213b;
}

#inputSearch {
    width: 380px;
    max-width: 430px;
    height: 50px;
    border-radius: 30px;
    font-size: 1.2rem;
    font-weight: 700;
    transition: all 0.5s;
    border: none;
}

#inputSearch:focus {
    width: 430px;
    box-shadow: inset 0 0 0 2px rgb(242, 19, 93);
}

#inputSearch::placeholder {
    font-size: 1.2rem;
    font-weight: 700;
}

#icon-search {
    position: absolute;
    transition: 0.5s;
    top: 50%;
    transform: translate(0, -50%);
    right: 10px !important;
}
</style>
